import React, { useMemo } from 'react'
import { Owner } from '@linqpal/models/src/mst/Owner'
import { Spacer } from '../../../../../ui/atoms'
import { InvitationSent, InviteFormInfo, QuestionLabel } from '../../components'
import { useEditorModel } from '../../useEditorModel'
import { UserDetailsForm } from '../businessOwner/UserDetailsForm'
import { observer } from 'mobx-react'
import { useResponsive } from '@linqpal/components/src/hooks'
import { toJS } from 'mobx'

function validate(value) {
  return value.allMandatoryFilled
}

export const InviteUser = observer((props) => {
  const { sm } = useResponsive()
  const { doc, group, item, onValueUpdate, review, reviewLabel } = props

  const model = useEditorModel(
    doc,
    group,
    item,
    onValueUpdate,
    '',
    validate,
    Owner,
  )

  const owner = useMemo(() => {
    return model.value ? Owner.create(toJS(model.value)) : Owner.create({})
  }, [model.value])

  const onChange = (value) => {
    model.setValue(item, value)
  }

  return (
    <>
      {review ? (
        <QuestionLabel>{reviewLabel}</QuestionLabel>
      ) : sm ? (
        <InviteFormInfo />
      ) : null}
      <UserDetailsForm user={owner} review={review} onChange={onChange} />
      {!sm && !review && (
        <>
          <Spacer height={30} />
          <InviteFormInfo />
        </>
      )}
      {review && (
        <>
          <Spacer height={20} />
          <InvitationSent document={doc} />
        </>
      )}
    </>
  )
})
